export default __webpack_public_path__ + "static/media/businessIconDark.37d319bf.svg";